export const SET_CANVAS = 'SET_CANVAS'